import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageContainer } from '@/components/layout/PageContainer'
import { Button } from '@/components/ui/button'
import { StorefrontSettingsGuard } from './StorefrontSettingsGuard'
import { ProductDisplaySettings } from './ProductDisplaySettings'
import { FilterAttributeSettings } from './FilterAttributeSettings'

export function ProductDisplayPage() {
  const navigate = useNavigate()

  return (
    <StorefrontSettingsGuard>
      <PageContainer>
        <div className="p-6 space-y-6">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full"
              onClick={() => navigate('/storefront/settings')}
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div>
              <h2 className="text-2xl font-semibold">Product Display</h2>
              <p className="text-sm text-muted-foreground">
                Viewer counts, stock display, and storefront filters
              </p>
            </div>
          </div>

          <ProductDisplaySettings />
          <FilterAttributeSettings />
          <p className="text-xs text-muted-foreground pl-4">
            Enabled attributes appear as filter options on your storefront
            collection pages.
          </p>
        </div>
      </PageContainer>
    </StorefrontSettingsGuard>
  )
}
